module.exports = __webpack_public_path__ + "img/person-2.d51e6f68.png";